import styled from '@emotion/styled';
import { KizenTypography } from '__app/typography';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import type { Step } from 'pages/AutomationEngine/types';
import { useAutomationsDispatch } from '__pages/AutomationEngine/store/react';
import { actions } from 'pages/AutomationEngine/store';

const DropWrapper = styled.span`
  position: absolute;
  top: -40px;
  right: 0px;
  left: 0px;
  height: 30px;
  display: flex;
  justify-content: center;
`;

const DropArea = styled.span<{ dropping: boolean }>`
  border: ${({ dropping }) => (dropping ? 'solid' : 'dashed')}
    var(--color-button-secondary-default) 1px;
  border-radius: 4px;
  background-color: var(--color-background-white);
  display: flex;
  padding: 0 10px;
`;

const CenteredText = styled(KizenTypography)`
  display: flex;
  justify-content: center;
  color: var(--color-button-secondary-default);
  flex-wrap: wrap;
  height: 100%;
  align-content: center;
`;

export const VariableDropzoneCard = ({ step }: { step: Step }) => {
  const { t } = useTranslation();
  const dispatch = useAutomationsDispatch();

  const [dropping, setDropping] = useState(false);

  const handleDropping = useCallback(
    (isDropping: boolean) => {
      setDropping(isDropping);
      dispatch(actions.setDroppingVariable(isDropping ? step : null));
    },
    [dispatch, step]
  );

  return (
    <DropWrapper>
      <DropArea
        data-qa={`drag-target-${step.id}`}
        dropping={dropping}
        onMouseEnter={() => handleDropping(true)}
        onMouseLeave={() => handleDropping(false)}
      >
        <CenteredText as="div">{t('Place Here')}</CenteredText>
      </DropArea>
    </DropWrapper>
  );
};
